import {HttpClient} from '@angular/common/http';
import {MixTranslateLoader} from '../../core/mix-translate-loader';
import {ConfigService} from '../../core/services/config.service';
import {ThemeService} from '../../core/services/theme.service';

export function createTranslateLoader(http: HttpClient, configs: ConfigService, themeService: ThemeService) {
    return new MixTranslateLoader(http, configs, themeService);
}
